import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRithmicAccountData, IAccountsBaseInfo } from "../../api/rithmic/index.types";
import { IGetActivityLogsResponse } from "../../api/agentActivityLog/index.types";

export interface IRithmicAccountsState {
  data: {
    e2tAccounts: IRithmicAccountData[];
    count: number;
    loading: boolean;
  };
  rithmicAccountsCreatingHistory: {
    data: IGetActivityLogsResponse["data"];
    loading: boolean;
  };
}

const initialState: IRithmicAccountsState = {
  data: {
    e2tAccounts: [],
    count: 0,
    loading: false,
  },
  rithmicAccountsCreatingHistory: {
    data: {
      logs: [],
      count: 0,
    },
    loading: false,
  },
};

interface AccountsFetchSuccessPayload {
  e2tAccounts: IRithmicAccountData[];
  count: number;
  accounts: IAccountsBaseInfo[];
}

const index = createSlice({
  name: "rithmicAccounts",
  initialState,
  reducers: {
    // RithmicAccounts
    fetchAccountsRequest: (state) => {
      state.data.loading = true;
    },
    fetchAccountsSuccess: (state, action: PayloadAction<AccountsFetchSuccessPayload>) => {
      state.data.loading = false;
      const { e2tAccounts, accounts, count } = action.payload;
      e2tAccounts.forEach(({ email }, index: number) => {
        const res = accounts.find((account) => account.email === email);
        if (res) {
          e2tAccounts[index].id = res.id;
        }
      });
      state.data.e2tAccounts = e2tAccounts;
      state.data.count = count;
    },
    fetchAccountsFailed: (state) => {
      state.data.loading = false;
    },
    // RithmicAccountsCreatingHistory
    fetchCreatingHistoryRequest: (state) => {
      state.rithmicAccountsCreatingHistory.loading = true;
    },
    fetchCreatingHistorySuccess: (
      state,
      action: PayloadAction<IGetActivityLogsResponse["data"]>
    ) => {
      state.rithmicAccountsCreatingHistory.loading = false;
      state.rithmicAccountsCreatingHistory.data = action.payload;
    },
    fetchCreatingHistoryFailed: (state) => {
      state.rithmicAccountsCreatingHistory.loading = false;
    },
  },
});

export const rithmicAccountsActions = index.actions;
export default index.reducer;
